import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export async function impersonate(body) {
  try {
    const { data } = await api.post("/admin/users/impersonate", body);
    localStorage.removeItem("activeCompanyId");
    toast.success(`Now viewing as ${data.label}`);
    window.location.href = "/dashboard";
  } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
}

export async function stopImpersonating() {
  try {
    await api.post("/admin/users/impersonate/stop");
    localStorage.removeItem("activeCompanyId");
    window.location.href = "/dashboard";
  } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
}
